import styled, { css } from 'styled-components';

import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';

export const Wrap = styled.div`

`;

export const TopWrap = styled.div`

`;

export const AgreeWrap = styled.div`
  height: auto;
  padding: 2% 4%;
  background-color: #F5F4F6;
`;

export const LabelWrap = styled.div`
  padding-left: 3%;
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  width: 100%;
  
  ${media.pcLarge`
    font-size: 20px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 14px;
  `}

  ${media.mobileMid`
    font-size: 14px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}

  font-weight: 700;
  color: #4a4b4c;
  letter-spacing: -1px;
`;

export const Checkbox = styled.input`
  ${checkboxStd};

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 20px;
    height: 20px;
  `}

  margin-right: 2%;
`;

export const QuestionWrap = styled.div`
  position: relative;

  > button {
    &.o {
      width: 36%;
      height: 28%;
      position: absolute;
      bottom: 10%;
      left: 12%;
      opacity: 0;
    }

    &.x {
      width: 36%;
      height: 28%;
      position: absolute;
      bottom: 10%;
      right: 12%;
      opacity: 0;
    }
  }
`;

export const ScoreWrap = styled.div`
  width: 94%;
  position: absolute;
  top: 4%;
  left: 50%;
  transform: translateX(-50%);
`;

export const QuizWrap = styled.div`
  width: 94%;
  position: absolute;
  bottom: 4%;
  left: 50%;
  transform: translateX(-50%);
`;

export const BottomWrap = styled.div`
  position: relative;

  > button {
    width: 56%;
    height: 10%;
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
  }
`;
